import { NotificationManager } from 'react-notifications';
import { FormattedMessage } from 'react-intl';

import { checkIfObject } from './checkHelpers';
import { STATUS_META } from './statusMeta';

interface NotificationError {
  response?: {
    data?: unknown;
    status?: number;
  };
}
const serverErrorMessage = STATUS_META()[500].msg;

const getErrorMessage = (value: unknown): string | undefined => {
  if (typeof value === 'string') {
    const message = value.trim();
    if (!message) return undefined;

    try {
      const parsedValue: unknown = JSON.parse(message);
      return parsedValue === message ? message : getErrorMessage(parsedValue);
    } catch (_error) {
      return message;
    }
  }

  if (!checkIfObject(value)) return undefined;

  for (const key of ['message', 'errorMessage', 'error', 'Payload']) {
    const message = getErrorMessage(value[key]);
    if (message) return message;
  }

  return undefined;
};

const tooManyInvalidationsErrorMessageTitle = (
  <FormattedMessage
    id="containers.ApiMiddleware.ErrorMessage.TooManyInvalidations.Title"
    defaultMessage="Caching failed"
  />
);

const tooManyInvalidationsErrorMessageDescription = (
  <FormattedMessage
    id="containers.ApiMiddleware.ErrorMessage.TooManyInvalidations.Description"
    defaultMessage={
      'All data was saved but changes will not be live on your website. ' +
      'Please wait for 5 minutes and save your changes afterwards again.'
    }
  />
);

function notify(error?: NotificationError | null) {
  const { response } = error || {};
  const { data, status } = response || {};

  if (status === 503) {
    NotificationManager.error(
      tooManyInvalidationsErrorMessageDescription,
      tooManyInvalidationsErrorMessageTitle,
      9000,
    );
    return;
  }

  const details = checkIfObject(data) ? data.details : undefined;
  const responseMessage = checkIfObject(data) ? data.message : undefined;
  const message =
    getErrorMessage(details) ||
    getErrorMessage(responseMessage) ||
    getErrorMessage(data) ||
    serverErrorMessage;

  NotificationManager.error(message, 'API Error');
}

export { notify };
